import { useEffect } from "react";
import axiosInstance from "../services/axiosInstance";
import { API_V2 } from "../models/GWDomain";

/**
 * Paywall AL ENTRAR (spec 007 US1 / spec 031 US4).
 *
 * El bloqueo por vencimiento era reactivo: el overlay aparecía cuando alguna
 * llamada devolvía 403, así que el usuario alcanzaba a ver la app antes de
 * quedar bloqueado. Este hook consulta el veredicto en cuanto monta el layout y
 * dispara el mismo evento que los interceptores, de modo que SubscriptionBlocked
 * se muestre de entrada.
 *
 * La regla NO se reimplementa acá: /account/subscription-status devuelve el
 * mismo veredicto que aplica el SubscriptionGuard (cuentas legacy sin fecha no
 * se bloquean, la prueba vencida bloquea siempre, el vencimiento general
 * depende del flag). El endpoint vive bajo /account, que está en la allowlist
 * del guard, por lo que responde incluso con la cuenta bloqueada.
 */
const useSubscriptionGate = () => {
  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const { data } = await axiosInstance.get(
          `${API_V2}/account/subscription-status`
        );
        const status = data?.data ?? data;
        if (cancelled || !status?.blocked) return;
        window.dispatchEvent(
          new CustomEvent("subscription-expired", {
            detail: {
              code: "SUBSCRIPTION_EXPIRED",
              reason: status.reason,
              expiredAt: status.expiredAt,
            },
          })
        );
      } catch {
        // Si la consulta falla no se bloquea nada: el guard del backend sigue
        // cortando las requests, así que el overlay aparecerá igual por la vía
        // reactiva. Nunca dejar al usuario fuera por un error de red.
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);
};

export default useSubscriptionGate;
